var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"month-order-box"},[_c('div',{staticClass:"month-order-tool"}),_c('div',{staticClass:"month-order-charts",attrs:{"id":"monthCharts"}})])
}]

export { render, staticRenderFns }